export const TRADE_PAIR_CATEGORIES = [
  {
    id: "currencies",
    label: "Currencies",
    instruments: [
      "USD/EGP (OTC)",
      "USD/MXN (OTC)",
      "USD/ARS (OTC)",
      "USD/IDR (OTC)",
      "AUD/JPY",
      "EUR/GBP",
      "EUR/NZD (OTC)",
      "EUR/USD",
      "NZD/CHF (OTC)",
      "NZD/JPY (OTC)",
      "EUR/JPY",
      "CAD/JPY",
      "GBP/USD",
      "AUD/USD",
      "GBP/JPY",
      "USD/JPY",
      "GBP/AUD",
      "USD/PHP (OTC)",
      "AUD/NZD (OTC)",
      "NZD/CAD (OTC)",
      "CAD/CHF (OTC)",
      "USD/COP (OTC)",
      "USD/CHF",
      "USD/DZD (OTC)",
      "AUD/CAD",
      "AUD/CHF",
      "EUR/AUD",
      "EUR/CAD",
      "USD/BRL (OTC)",
      "CHF/JPY",
      "GBP/CAD",
      "USD/BDT (OTC)",
      "USD/CAD",
      "USD/INR (OTC)",
      "USD/NGN (OTC)",
      "USD/PKR (OTC)",
      "GBP/CHF",
      "EUR/CHF",
      "GBP/NZD (OTC)",
      "NZD/USD (OTC)",
      "USD/ZAR (OTC)",
    ],
  },
  {
    id: "crypto",
    label: "Crypto",
    instruments: [
      "Bitcoin (OTC)",
      "Polkadot (OTC)",
      "Solana (OTC)",
      "Dash (OTC)",
      "Ethereum (OTC)",
      "Binance Coin (OTC)",
      "Chainlink (OTC)",
      "Toncoin (OTC)",
      "Avalanche (OTC)",
      "Axie Infinity (OTC)",
      "Litecoin (OTC)",
      "Zcash (OTC)",
      "Bitcoin Cash (OTC)",
      "Ripple (OTC)",
      "Trump (OTC)",
      "Ethereum Classic (OTC)",
      "Cosmos (OTC)",
    ],
  },
  {
    id: "commodities",
    label: "Commodities",
    instruments: [
      "Gold (OTC)",
      "USCrude (OTC)",
      "UKBrent (OTC)",
      "Silver (OTC)",
    ],
  },
  {
    id: "stocks",
    label: "Stocks",
    instruments: [
      "EURO STOXX 50",
      "S&P/ASX 200",
      "FTSE China A50 Index",
      "CAC 40",
      "FTSE 100",
      "Hong Kong 50",
      "IBEX 35",
      "Nikkei 225",
    ],
  },
];

export const DEFAULT_TRADE_PAIR = "EUR/USD";
